module.exports = __webpack_public_path__ + "img/594.20a0c102.jpg";